import Vue from 'vue';
import PublicMainBanner from './components/publicSchedule/PublicMainBanner.vue';
import store from './store/publicSchedule';
import router from './router/public';

if (document.getElementById('publicAppBanner')) {
  new Vue({
    name: 'PublicMainBanner',
    el: '#publicAppBanner',
    template: '<PublicMainBanner/>',
    store,
    router,
    components: {
      PublicMainBanner,
    },
  });
}
